"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnIfFragment = void 0;

var _reactIs = require("react-is");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var warnIfFragment = function warnIfFragment(node, componentName) {
  var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';

  if (process.env.NODE_ENV !== 'production' && (0, _reactIs.isFragment)(node)) {
    _devLogger.default.warn({
      message: componentName + ": " + propName + " cannot be a React.Fragment. Please refactor to use a DOM node.",
      key: componentName + ": fragment not supported"
    });
  }
};

exports.warnIfFragment = warnIfFragment;